import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { useState } from "react";

const KnowledgeBase = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    return (
        <>
            <div className="main_title">
                <h1>Knowledge Base View</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    <button onClick={() => navigate("/admin-support")}>
                        Admin Support Management
                    </button>
                    - Knowledge Base
                </p>
            </div>
            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search..."
                        />
                    </div>
                </div>
                <div className="help-center-grid">
                    {[
                        {
                            title: "Create Your Store",
                            subtitle: "A Step-by-Step Guide",
                            time: "2 min read",
                        },
                        {
                            title: "How to Add Your First Product",
                            subtitle: "",
                            time: "2 min read",
                        },
                        {
                            title: "Bouteek Vendor Dashboard",
                            subtitle: "Overview",
                            time: "2 min read",
                        },
                        {
                            title: "Understanding Marketplace Rules",
                            subtitle: "",
                            time: "2 min read",
                        },
                        {
                            title: "Bouteek Vendor Dashboard",
                            subtitle: "Overview",
                            time: "2 min read",
                        },
                        {
                            title: "How to Add Your First Product",
                            subtitle: "",
                            time: "2 min read",
                        },
                    ].map((item, i) => (
                        <div className="help-card" key={i}>
                            <div className="help-icon">
                                📄
                            </div>

                            <div>
                                <h4>{item.title}</h4>
                                {item.subtitle && <p className="sub">{item.subtitle}</p>}
                                <span className="time">{item.time}</span>
                            </div>
                        </div>
                    ))}
                </div>

            </div>

        </>
    );
}
export default KnowledgeBase;